import styled from '@emotion/styled';
import React from 'react'
// --- external imports ------

import Asset from '../GameAsset/BaseAssets';
// --- project imports ------

function AssetHeader(props) {
	return (
		<HeaderStyled
				x={props.x}
				y={props.y}
				fontSize={58}
			>
			{props.children}
		</HeaderStyled>
	);
}

const HeaderStyled = styled(Asset.Text)`
	text-shadow: -0.069em 0.034em 0 #d63b25;
	color: #f2c218;
	font-family: "Keys of Paradise";
	line-height: 1em;
`;

export default AssetHeader;
